import NewsItem from "./NewsItem.vue.js";
import NewsTopBlock from "./NewsTopBlock.vue.js";
import EmptyData from "../../Base/EmptyData.vue.js";
import Layout from "../../../constants/Layout.js";
import { NEWS } from "../../../graphql/news.js";
import "../../../plugins/apollo.js";
import "lodash-es";
import "moment";
import { resolveComponent, createElementBlock, openBlock, Fragment, createCommentVNode, createBlock, createVNode, withCtx, createElementVNode } from "vue";
import "../../../constants/UserPolicy.js";
import "pinia";
import "../../../store/index.js";
import "../../../plugins/i18n.js";
import "../../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import { useLocalePath } from "../../../composables/useLocalePath.js";
import "../../../graphql/queries.js";
import "../../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../../constants/components/index.js";
/* empty css                            */
import "vuetify/components/VDialog";
import "../../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                           */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import { VProgressCircular } from "vuetify/components/VProgressCircular";
/* empty css                                     */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                    */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../../Auth/AppleAuthButton/AppleAuthButton.js";
import "../../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                                  */
import "vuetify/components/VGrid";
import "../../Base/index.js";
import "vuex";
/* empty css                           */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../../icons/mdi/index.js";
/* empty css                               */
import "vuetify/components/VBtnToggle";
import "../../../assets/6f5dc1ff0a697731.svg";
import "../../../assets/888bb8db73be3c15.svg";
/* empty css                                */
import "vuetify/components/VInfiniteScroll";
/* empty css                                     */
/* empty css                         */
import "vuetify/components/VChip";
/* empty css                             */
import "../../HtmlEditor/index.js";
import "../../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                                  */
/* empty css                           */
import "./NewsModule.vue.js";
/* empty css                           */
import "../../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                    */
import "vuetify/components/VWindow";
import "../../../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
import "../../../graphql/system-settings.js";
/* empty css                                */
/* empty css                               */
import "vuetify/components/VHover";
import "../../../constants/NewsGroup.js";
/* empty css                                */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                      */
import "vuetify/components/VBottomSheet";
import "../../../graphql/favorites.js";
import "../../../plugins/tracker/page-tracker.js";
/* empty css                        */
import "../../../graphql/notifications.js";
/* empty css                                     */
import "../../../constants/CommunicationChannels.js";
/* empty css                               */
import "vuetify/components/VColorPicker";
/* empty css                                                   */
import "vuetify/components/VTextarea";
/* empty css                               */
import "vuetify/components/VTooltip";
/* empty css                                                */
/* empty css                             */
import "graphql-tag";
import "../../../graphql/lookups.js";
import "../../../graphql/entity.js";
/* empty css                          */
import "vuetify/components";
/* empty css                                */
/* empty css                        */
import "../../../graphql/system-events.js";
/* empty css                                           */
/* empty css                            */
/* empty css                            */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css                                    */
/* empty css                                                  */
import "vuetify/components/VAlert";
/* empty css                                       */
import "vue-dndrop";
/* empty css                                               */
/* empty css                                       */
import "vue-advanced-cropper";
import "../../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                           */
import "vuetify/components/VFileInput";
/* empty css                               */
import "vuetify/components/VAvatar";
/* empty css                                     */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                                 */
import "../../../graphql/public-articles.js";
/* empty css                                              */
/* empty css                                  */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                     */
import "vuetify/components/VItemGroup";
/* empty css                                */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                           */
import "../../../graphql/quartz.js";
import "vue-i18n";
import "../../../graphql/integration-systems.js";
import "../../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                         */
/* empty css                                       */
import "../../../graphql/session-store.js";
import "../../../composables/useModalPage.js";
import "../../../icons/portal/index.js";
const _sfc_main = {
  name: "NewsList",
  components: {
    NewsItem,
    NewsTopBlock,
    EmptyData
  },
  props: {
    layout: {
      type: Number,
      default: Layout.Cards
    },
    useTopBlock: {
      type: Boolean,
      default: true
    },
    useWideLayout: {
      type: Boolean,
      default: false
    },
    where: {
      type: Object,
      default: null
    },
    fromModule: {
      type: Boolean,
      default: false
    }
  },
  emits: ["tagClick"],
  setup() {
    const localePath = useLocalePath();
    return { localePath };
  },
  data() {
    return {
      items: [],
      take: 20,
      hasNextPage: false,
      isLoading: false,
      rowKey: 0
    };
  },
  computed: {
    topItems() {
      return this.useTopBlock ? this.items.slice(0, 4) : [];
    },
    masonryItems() {
      return this.useTopBlock ? this.items.slice(4) : this.items;
    },
    masonryColumns() {
      return this.$vuetify.display.lgAndUp ? 4 : this.$vuetify.display.md ? 3 : this.$vuetify.display.sm ? 2 : 1;
    }
  },
  watch: {
    where: {
      handler() {
        this.refetchData();
      },
      deep: true
    }
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    tagClickHandler(tag) {
      if (!(tag == null ? void 0 : tag.id)) {
        return;
      }
      if (this.fromModule) {
        this.$emit("tagClick", tag);
      } else {
        this.$router.push(
          this.localePath(`/news?tagName=${tag.name}&tagId=${tag.id}`)
        );
      }
    },
    async fetchData() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const { data } = await this.$apollo.query({
        query: NEWS,
        variables: {
          take: this.take,
          skip: this.items.length,
          order: { entity: { publishedOn: "DESC" } },
          ...this.where && { where: this.where }
        },
        fetchPolicy: "no-cache"
      });
      const pageInfo = data == null ? void 0 : data.items.pageInfo;
      if (pageInfo) {
        this.hasNextPage = pageInfo.hasNextPage;
      }
      const items = data == null ? void 0 : data.items.items;
      if (items) {
        this.items = [...this.items, ...items];
      }
      this.isLoading = false;
    },
    async refetchData() {
      this.items.length = 0;
      this.hasNextPage = false;
      await this.fetchData();
    }
  }
};
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center align-center flex-grow-1 mt-4"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NewsTopBlock = resolveComponent("NewsTopBlock");
  const _component_news_item = resolveComponent("news-item");
  const _component_masonry_wall = resolveComponent("masonry-wall");
  const _component_b_client_only = resolveComponent("b-client-only");
  const _component_EmptyData = resolveComponent("EmptyData");
  const _component_infinite_loading = resolveComponent("infinite-loading");
  return openBlock(), createElementBlock(Fragment, null, [
    $data.isLoading && $data.items.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_1, [
      createVNode(VProgressCircular, {
        size: 50,
        color: "primary",
        indeterminate: ""
      })
    ])) : createCommentVNode("", true),
    $options.topItems.length ? (openBlock(), createBlock(_component_NewsTopBlock, {
      key: 1,
      data: $options.topItems
    }, null, 8, ["data"])) : createCommentVNode("", true),
    $options.masonryItems.length ? (openBlock(), createBlock(_component_b_client_only, { key: 2 }, {
      default: withCtx(() => [
        createVNode(_component_masonry_wall, {
          items: $options.masonryItems,
          gap: 16,
          "min-columns": $options.masonryColumns
        }, {
          default: withCtx(({ item }) => [
            createVNode(_component_news_item, {
              "entity-with-like": item,
              onTagClick: $options.tagClickHandler
            }, null, 8, ["entity-with-like", "onTagClick"])
          ]),
          _: 1
        }, 8, ["items", "min-columns"])
      ]),
      _: 1
    })) : createCommentVNode("", true),
    !$data.isLoading && $data.items.length === 0 ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
      _ctx.$auth.hasPolicy(_ctx.$auth.userPolicy.NewsEditor.code) ? (openBlock(), createBlock(_component_EmptyData, {
        key: 0,
        img: _ctx.$img.presets.NewsEmptyImg.attrs.src,
        title: _ctx.$t("components.news.news_list.no_news"),
        subtitle: _ctx.$t("components.news.news_list.empty_hint")
      }, null, 8, ["img", "title", "subtitle"])) : (openBlock(), createBlock(_component_EmptyData, {
        key: 1,
        img: _ctx.$img.presets.NewsEmptyImgForUser.attrs.src,
        title: _ctx.$t("components.news.news_list.no_news_for_user"),
        subtitle: _ctx.$t("components.news.news_list.empty_hint_for_user")
      }, null, 8, ["img", "title", "subtitle"]))
    ], 64)) : createCommentVNode("", true),
    $data.hasNextPage && !$data.isLoading && $data.items.length > 0 ? (openBlock(), createBlock(_component_infinite_loading, {
      key: 4,
      distance: 300,
      onInfinite: _cache[0] || (_cache[0] = ($event) => $options.fetchData())
    }, {
      "no-results": withCtx(() => _cache[1] || (_cache[1] = [
        createElementVNode("div", null, null, -1)
      ])),
      "no-more": withCtx(() => _cache[2] || (_cache[2] = [
        createElementVNode("div", null, null, -1)
      ])),
      _: 1
    })) : createCommentVNode("", true)
  ], 64);
}
const NewsList = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  NewsList as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
